import React, { useEffect, useRef, useState } from 'react';
import { Portal } from 'react-portal';
import AnnouncementCloseButton from './AnnouncementCloseButton';
import './UPAnnouncements.less';

function getPreviewSize() {
  const maxHeight = window.innerHeight * 0.8;
  const horizontalFrame = 34;
  const verticalFrame = 134;
  const width = Math.min(window.innerWidth * 0.8, (maxHeight - verticalFrame) * 1.5 + horizontalFrame, 1200);
  return { width, height: Math.min(maxHeight, (width - horizontalFrame) / 1.5 + verticalFrame) };
}

export default function AnnouncementImagePreview({ image, pms, onClose }) {
  const dialog = useRef(null);
  const caption = useRef(null);
  const [size, setSize] = useState(getPreviewSize);

  useEffect(() => {
    const element = dialog.current;
    const trigger = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    const updateSize = () => setSize(getPreviewSize());
    element.showModal();
    caption.current.focus({ preventScroll: true });
    document.body.style.overflow = 'hidden';
    window.addEventListener('resize', updateSize);
    return () => {
      window.removeEventListener('resize', updateSize);
      element.close();
      document.body.style.overflow = previousOverflow;
      if (trigger?.isConnected) trigger.focus({ preventScroll: true });
    };
  }, []);

  return (
    <Portal>
      <dialog
        ref={dialog}
        styleName="lightbox"
        style={size}
        aria-labelledby="up-connect-preview-caption"
        aria-modal="true"
        data-announcement-lightbox="true"
        data-testid="extension-announcement-image-preview"
        onCancel={(event) => { event.preventDefault(); onClose(); }}
        onKeyDown={(event) => event.stopPropagation()}
        onClick={(event) => {
          const bounds = event.currentTarget.getBoundingClientRect();
          if (event.target === event.currentTarget
            && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) onClose();
        }}
      >
        <div styleName="lightboxToolbar">
          <AnnouncementCloseButton onClick={onClose} label="Close image preview" title="Back to announcement (Esc)" />
        </div>
        <figure styleName="lightboxFigure">
          <button type="button" styleName="lightboxImage" onClick={onClose} aria-label="Return to announcement" title="Back to announcement">
            <img styleName="previewImage" src={image} alt={`Example of Utility Profit utility details inside ${pms}`} width="1200" height="800" />
          </button>
          <figcaption ref={caption} id="up-connect-preview-caption" styleName="lightboxCaption" tabIndex="-1">
            Example utility details in {pms}.
          </figcaption>
        </figure>
      </dialog>
    </Portal>
  );
}
